import { Box, BoxProps } from '@chakra-ui/react';

interface AsteriskProps extends BoxProps {
  size?: string;
}

export function Asterisk({ size = '14px', ...props }: AsteriskProps) {
  return (
    <Box
      as="span"
      className="spin-slow"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w={size}
      h={size}
      lineHeight="1"
      color="accent.500"
      fontFamily="display"
      fontSize={size}
      style={{ transformOrigin: 'center' }}
      aria-hidden="true"
      {...props}
    >
      *
    </Box>
  );
}
